const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  arrow_down: 'e913',
  arrow_next: 'e914',
  arrow_prev: 'e915',
  arrow_up_circle_fill: 'e916',
  arrowcircle: 'e917',
  arrowhead: 'e918',
  attach: 'e919',
  audio_repeat: 'e91a',
  audio_repeat_single: 'e91b',
  author_hidden: 'e91c',
  auto_delete_circle_1: 'e91d',
  auto_delete_circle_2: 'e91e',
  auto_delete_circle_3: 'e91f',
  auto_delete_circle_4: 'e920',
  auto_delete_circle_5: 'e921',
  auto_delete_circle_6: 'e922',
  auto_delete_circle_clock: 'e923',
  auto_delete_circle_days: 'e924',
  auto_delete_circle_empty: 'e925',
  auto_delete_circle_months: 'e926',
  auto_delete_circle_off: 'e927',
  auto_delete_circle_weeks: 'e928',
  auto_delete_circle_years: 'e929',
  avatarnext: 'e92a',
  avatarprevious: 'e92b',
  aversion: 'e92c',
  back: 'e92d',
  binfilled: 'e92e',
  bold: 'e92f',
  bomb: 'e930',
  boost: 'e931',
  boostcircle: 'e932',
  bot_filled: 'e933',
  botcom: 'e934',
  bots: 'e935',
  brightness: 'e936',
  brush: 'e937',
  bubblereply: 'e938',
  bug: 'e939',
  calendar: 'e93a',
  calendarfilter: 'e93b',
  camera: 'e93c',
  cameraadd: 'e93d',
  captiondown: 'e93e',
  captionup: 'e93f',
  car: 'e940',
  card: 'e941',
  card_outline: 'e942',
  cash_circle: 'e943',
  channel: 'e944',
  channel_filled: 'e945',
  channelviews: 'e946',
  chatspinned: 'e947',
  chatsplaceholder: 'e948',
  check1: 'e949',
  checkbox: 'e94a',
  checkboxblock: 'e94b',
  checkboxempty: 'e94c',
  checkboxon: 'e94d',
  checklist_add: 'e94e',
  checklist_done: 'e94f',
  checklist_undone: 'e950',
  checkretract: 'e951',
  checkround: 'e952',
  checkround_filled: 'e953',
  clipboard: 'e954',
  clock: 'e955',
  close: 'e956',
  clouddownload: 'e957',
  collapse: 'e958',
  colorize: 'e959',
  comments: 'e95a',
  commentssticker: 'e95b',
  contrast: 'e95c',
  copy: 'e95d',
  crop: 'e95e',
  cross: 'e95f',
  crossgif: 'e960',
  crossround: 'e961',
  crossround_filled: 'e962',
  crossstar: 'e963',
  crown: 'e964',
  crown_outline: 'e965',
  crownalt: 'e966',
  crownoff: 'e967',
  crownoff_outline: 'e968',
  darkmode: 'e969',
  data: 'e96a',
  delete: 'e96b',
  delete_filled: 'e96c',
  deletedaccount: 'e96d',
  deleteleft: 'e96e',
  deleteuser: 'e96f',
  devices: 'e970',
  document: 'e971',
  dollar_circle: 'e972',
  dollar_circle_x: 'e973',
  down: 'e974',
  down_up: 'e975',
  download: 'e976',
  dragfiles: 'e977',
  dragmedia: 'e978',
  eats: 'e979',
  edit: 'e97a',
  email: 'e97b',
  endcall_filled: 'e97c',
  enhance: 'e97d',
  enter: 'e97e',
  equalizer: 'e97f',
  expand: 'e980',
  eye: 'e981',
  eye1: 'e982',
  eye2: 'e983',
  eyecross_outline: 'e984',
  faceid: 'e985',
  factcheck: 'e986',
  fade: 'e987',
  fast_forward: 'e988',
  fast_rewind: 'e989',
  favourites: 'e98a',
  filter: 'e98b',
  flag: 'e98c',
  flip: 'e98d',
  flip_image_horizontal: 'e98e',
  folder: 'e98f',
  fontframe: 'e990',
  fontframe_bg: 'e991',
  fontframe_outline: 'e992',
  fontsize: 'e993',
  forward: 'e994',
  forward_filled: 'e995',
  free_transform: 'e996',
  fullscreen: 'e997',
  gc_microphone: 'e998',
  gc_microphoneoff: 'e999',
  gem: 'e99a',
  gem_exchange: 'e99b',
  gem_transfer: 'e99c',
  gem_transfer_outline: 'e99d',
  geometric_digit_0: 'e99e',
  geometric_digit_1: 'e99f',
  geometric_digit_2: 'e9a0',
  geometric_digit_3: 'e9a1',
  geometric_digit_4: 'e9a2',
  geometric_digit_5: 'e9a3',
  geometric_digit_6: 'e9a4',
  geometric_digit_7: 'e9a5',
  geometric_digit_8: 'e9a6',
  geometric_digit_9: 'e9a7',
  geometric_dot: 'e9a8',
  geometric_letter_x: 'e9a9',
  gifs: 'e9aa',
  gift: 'e9ab',
  gift_premium: 'e9ac',
  grain: 'e9ad',
  group: 'e9ae',
  group_filled: 'e9af',
  group_star: 'e9b0',
  groupmedia: 'e9b1',
  groupmediaoff: 'e9b2',
  hand: 'e9b3',
  help: 'e9b4',
  hide: 'e9b5',
  highlights: 'e9b6',
  hourglass: 'e9b7',
  image: 'e9b8',
  image_original: 'e9b9',
  info: 'e9ba',
  info2: 'e9bb',
  italic: 'e9bc',
  key: 'e9bd',
  keyboard: 'e9be',
  lamp: 'e9bf',
  language: 'e9c0',
  largepause: 'e9c1',
  largeplay: 'e9c2',
  left: 'e9c3',
  limit_chat: 'e9c4',
  limit_chats: 'e9c5',
  limit_file: 'e9c6',
  limit_folders: 'e9c7',
  limit_link: 'e9c8',
  limit_pin: 'e9c9',
  link: 'e9ca',
  link_paid: 'e9cb',
  list: 'e9cc',
  listscreenshare: 'e9cd',
  livelocation: 'e9ce',
  location: 'e9cf',
  lock: 'e9d0',
  lockoff: 'e9d1',
  loginlogodesktop: 'e9d2',
  loginlogomobile: 'e9d3',
  logout: 'e9d4',
  mac_command_key: 'e9d5',
  mediaspeed_empty: 'e9d6',
  mediaspoiler: 'e9d7',
  mediaspoileroff: 'e9d8',
  mention: 'e9d9',
  menu: 'e9da',
  menu_feature_cover: 'e9db',
  menu_feature_unique: 'e9dc',
  menu_verification: 'e9dd',
  message: 'e9de',
  message_jump: 'e9df',
  message_quote: 'e9e0',
  messageunread: 'e9e1',
  microphone: 'e9e2',
  microphone_crossed: 'e9e3',
  microphone_crossed_filled: 'e9e4',
  microphone_filled: 'e9e5',
  minus: 'e9e6',
  monospace: 'e9e7',
  more: 'e9e8',
  multistories: 'e9e9',
  mute: 'e9ea',
  muted: 'e9eb',
  mynotes: 'e9ec',
  newchannel: 'e9ed',
  newchannel_filled: 'e9ee',
  newchat_filled: 'e9ef',
  newgroup: 'e9f0',
  newgroup_filled: 'e9f1',
  newprivate: 'e9f2',
  newprivate_filled: 'e9f3',
  newtab: 'e9f4',
  next: 'e9f5',
  nochannel: 'e9f6',
  noncontacts: 'e9f7',
  nosound: 'e9f8',
  okay: 'e9f9',
  online: 'e9fa',
  passwordoff: 'e9fb',
  pause: 'e9fc',
  permissions: 'e9fd',
  person: 'e9fe',
  phone: 'e9ff',
  phone_filled: 'ea00',
  pin: 'ea01',
  pin2: 'ea02',
  pinlist: 'ea03',
  pinned_filled: 'ea04',
  pinnedchat: 'ea05',
  pip: 'ea06',
  play: 'ea07',
  playback_05: 'ea08',
  playback_15: 'ea09',
  playback_1x: 'ea0a',
  playback_2x: 'ea0b',
  plus: 'ea0c',
  plusround: 'ea0d',
  poll: 'ea0e',
  premium_addone: 'ea0f',
  premium_avatars: 'ea10',
  premium_badge: 'ea11',
  premium_colors: 'ea12',
  premium_double: 'ea13',
  premium_emoji: 'ea14',
  premium_filesize: 'ea15',
  premium_lastseen: 'ea16',
  premium_limits: 'ea17',
  premium_lock: 'ea18',
  premium_management: 'ea19',
  premium_noads: 'ea1a',
  premium_privacy: 'ea1b',
  premium_reactions: 'ea1c',
  premium_restrict: 'ea1d',
  premium_speed: 'ea1e',
  premium_status: 'ea1f',
  premium_stickers: 'ea20',
  premium_tags: 'ea21',
  premium_transcription: 'ea22',
  premium_translate: 'ea23',
  premium_unlock: 'ea24',
  premium_wallpaper: 'ea25',
  previous: 'ea26',
  promote: 'ea27',
  quote: 'ea28',
  quote_outline: 'ea29',
  radiooff: 'ea2a',
  radioon: 'ea2b',
  reactions: 'ea2c',
  reactions_filled: 'ea2d',
  readchats: 'ea2e',
  recent: 'ea2f',
  redo: 'ea30',
  reload_star: 'ea31',
  replace: 'ea32',
  reply: 'ea33',
  reply_filled: 'ea34',
  restrict: 'ea35',
  revenue: 'ea36',
  rightpanel: 'ea37',
  rotate: 'ea38',
  rotate_left: 'ea39',
  rotate_right: 'ea3a',
  round_chats_filled: 'ea3b',
  saturation: 'ea3c',
  saved: 'ea3d',
  savedmessages: 'ea3e',
  schedule: 'ea3f',
  scheduled: 'ea40',
  search: 'ea41',
  select: 'ea42',
  send: 'ea43',
  send2: 'ea44',
  sending: 'ea45',
  sendingerror: 'ea46',
  settings: 'ea47',
  settings_clipped_corner: 'ea48',
  settings_filled: 'ea49',
  shadows: 'ea4a',
  sharescreen_filled: 'ea4b',
  sharpen: 'ea4c',
  shipping: 'ea4d',
  shuffle: 'ea4e',
  smallscreen: 'ea4f',
  smile: 'ea50',
  sort_date: 'ea51',
  sort_num: 'ea52',
  sort_price: 'ea53',
  speaker: 'ea54',
  speakerfilled: 'ea55',
  speakeroff: 'ea56',
  speakerofffilled: 'ea57',
  spoiler: 'ea58',
  sport: 'ea59',
  star: 'ea5a',
  star_filled: 'ea5b',
  statistics: 'ea5c',
  stickers: 'ea5d',
  stickers_face: 'ea5e',
  stop: 'ea5f',
  stories: 'ea60',
  storyreply: 'ea61',
  storyrepost: 'ea62',
  strikethrough: 'ea63',
  suggested: 'ea64',
  tag: 'ea65',
  tag_add: 'ea66',
  tag_alt: 'ea67',
  tag_alt_crossed: 'ea68',
  tag_alt_outline: 'ea69',
  tag_crossed: 'ea6a',
  tag_filter: 'ea6b',
  tag_name: 'ea6c',
  text: 'ea6d',
  textedit: 'ea6e',
  time_lock: 'ea6f',
  timer: 'ea70',
  tip: 'ea71',
  ton: 'ea72',
  tools: 'ea73',
  topics: 'ea74',
  trade: 'ea75',
  transcribe: 'ea76',
  unarchive: 'ea77',
  unclaimed: 'ea78',
  underline: 'ea79',
  undo: 'ea7a',
  unmute: 'ea7b',
  unpack: 'ea7c',
  unpin: 'ea7d',
  unread: 'ea7e',
  up: 'ea7f',
  up_down: 'ea80',
  user: 'ea81',
  username: 'ea82',
  videocamera: 'ea83',
  videocamera_crossed_filled: 'ea84',
  videocamera_filled: 'ea85',
  videochat: 'ea86',
  vignette: 'ea87',
  volume_down: 'ea88',
  volume_mute: 'ea89',
  volume_off: 'ea8a',
  volume_up: 'ea8b',
  warmth: 'ea8c',
  warning: 'ea8d',
  webview: 'ea8e',
  win_key: 'ea8f',
  zoomin: 'ea90',
  zoomout: 'ea91'
};

export default Icons;
